import React, { useState } from 'react';
import { makeStyles, Typography, Popper, Paper } from '~/lib/bn-material-ui';
import classnames from 'classnames';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  progressBar: {
    display: 'flex',
    width: '100%',
    border: `1px solid ${theme.palette.common.black}`,
    backgroundColor: theme.palette.common.white,
    borderRadius: '3px',
    height: '0.75rem',
    '& > div': {
      height: 'calc(0.75rem - 2px)',
    },
  },
  percent: {
    marginLeft: '0.5rem',
  },
  paper: {
    padding: '0.5rem',
  },
}));

interface MultiProgressBarValue {
  label: string;
  percent: number;
  color: string;
}

interface BnMultiProgressBarProps {
  values: MultiProgressBarValue[];
  className?: string;
}

export function BnMultiProgressBar({ values, className } : BnMultiProgressBarProps) {
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLElement | null>(null);
  const styles = useStyles();
  const totalProgress = values.reduce((acc, value) => acc + value.percent, 0);

  return (
    <div className={classnames(styles.container, className)}>
      <div
        className={styles.progressBar}
        onMouseEnter={(e) => setPopoverAnchor(e.currentTarget)}
        onMouseLeave={() => setPopoverAnchor(null)}
      >
        {values.map((value) => (
          <div
            key={value.label}
            style={{ backgroundColor: value.color, width: `${value.percent}%` }}
          />
        ))}
      </div>
      <Typography className={styles.percent} variant='body2'>{`${Math.round(totalProgress)}%`}</Typography>
      <Popper
        open={popoverAnchor !== null}
        anchorEl={popoverAnchor}
        placement='right-start'
        modifiers={[
          {
            name: 'preventOverflow',
            enabled: true,
            options: {
              boundariesElement: 'scrollParent',
            },
          },
        ]}
      >
        <Paper className={styles.paper}>
          {values.map((value) => (
            <div key={value.label}>
              <div style={{ backgroundColor: value.color }} />
              <Typography variant='body2'>{`${value.label}: ${Math.round(value.percent)}%`}</Typography>
            </div>
          ))}
        </Paper>
      </Popper>
    </div>
  );
}
